import React, { useContext } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { DataContext } from "../../../js/App";

const DropdownSelect = ({ name, fieldLabel, options, claimantSelect, labelPlaceholder, placeholder }) => {
  const context = useContext(DataContext);

  const { handleChangeSelect } = context;

  return (
    <Form.Group as={Row} className="mb-3" controlId="initialDropdownSelect">
      <Form.Label column sm="5">
        {fieldLabel}
        {labelPlaceholder && (<span className="label-placeholder" dangerouslySetInnerHTML={{__html: placeholder}}></span>)}
      </Form.Label>
      <Col sm="7">
        <Form.Select name={name} onChange={(e) => handleChangeSelect(e, claimantSelect)}>
          <option key={-1}>Please select...</option>
          {options.map((option, index) => (
            <option key={index} value={option.id}>{option.value}</option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  );
};

export default DropdownSelect;
